import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  fetchCaseDetailsById,
  updateCaseDetailsData,
  updateMotorCaseDetailsData,
} from "../../redux/actions/CaseDetailsActions";
import FormInput from "../FormInput";
import { useParams, useLocation } from "react-router-dom";
import MotorCaseUpdateFields, {
  buildMotorOdUpdatePayload,
  mapMotorOdDetailsToFormData,
} from "./case-initiated/MotorCaseUpdateFields";
import {
  CLAIM_TYPE_CATEGORY,
  isMotorClaimType,
} from "../../constants/claimTypeCategory";
import { resolveCaseClaimCategory } from "../../util/caseCategoryNavigation";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllStateList, getAllCityStateWiseList, getAllRelationshipList, getAllOccupationList, getAllLocalityList, 
  getAllEducationalList, getAllJobList, getAllRoomCategoryList, getAllIncomeDetailsList, getAllInjuryTypeList, 
  getMasterInsuranceList, getAllInsuranceManagerWiseList, getMasterHospitalList, getMasterClaimTypeList, getMasterUserUserTypeWiseList, getMasterUsertypeUserWiseList,
  getMasterBackendOfficerList,
  getMasterCaseManagerList,
  getMasterInsuranceTpaList
} from "../../redux/actions/MasterActions";
import AddInsuranceManagerManager from "./AddInsuranceManager";
import AddHospital from "./AddHospital";
import AddTypeOfClaim from "./AddTypeOfClaim";
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { getCurrentDateMysql, getCurrentTimeMysql, getDateTimeMysqlGivenFormatYmd} from '../../util/generalUtills'
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const UpdateCaseDetails = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [kycType, setKycType] = useState(null);
  const [kycNumber, setKycNumber] = useState("");
  const [kycFormatNote, setKycFormatNote] = useState("");
  const [kycValidationError, setKycValidationError] = useState("");
  const [kycEntries, setKycEntries] = useState([]);
  const [insuranceId, setInsuranceId] = useState(null);
  const [dobDate, setDobDate] = useState(null);
  const [caseManagerUserTypeId, setCaseManagerUserTypeId] = useState(null);

  const [showInsuranceManagerModel, setShowInsuranceManagerModel] = useState(false);
  const hideInsuranceManagerModel = () => {
    setShowInsuranceManagerModel(false);
    dispatch(getAllInsuranceManagerWiseList(auth.token, insuranceId));
  };

  const [showHospitalModel, setShowHospitalModel] = useState(false);
  const hideHospitalModel = () => {
    setShowHospitalModel(false);
    dispatch(getMasterHospitalList(auth.token));
  };

  const [showTypeOfClaimModel, setShowTypeOfClaimModel] = useState(false);
  const hideTypeOfClaimModel = () => {
    setShowTypeOfClaimModel(false);
    dispatch(getMasterClaimTypeList(auth.token));
  };

  const handleDateChange = (date) => {
    setDobDate(date);
  };

  const genderList = [
    {
      id: "Male",
      name: 'Male'
    },
    {
      id: "Female",
      name: 'Female'
    },
    {
      id: "Other",
      name: 'Other'
    }
  ]

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    caseDetailsReducer: {
      caseDetailsLists,
      loadingCaseDetails,
      errorsCaseDetails,
      changedCaseDetailsStatus,
      motorCaseDetailsLists,
      loadingMotorCaseDetails,
      errorsMotorCaseDetails,
      changedMotorCaseDetailsStatus,
    },
    masterReducer: {
      masterInsuranceList,
      masterInsuranceManagerWiseList,
      masterHospitalList,
      masterClaimTypeList,
      masterStateLists,
      masterCityStateWiseLists,
      masterRelationshipList,
      masterOccupationList,
      masterLocalityList,
      masterEducationalList,
      masterJobList,
      masterRoomCategoryList,
      masterIncomeDetailsList,
      masterInjuryTypeList,
      loadingMaster,
      errorsMaster,
      masterUsertypeLists,
      masterCaseManagerLists,
      masterInsuranceTpaList,
    },
  } = useSelector((state) => state);

  const isMotorCase = useMemo(() => {
    if (resolveCaseClaimCategory(location.pathname) === CLAIM_TYPE_CATEGORY.MOTOR) {
      return true;
    }
    const healthData =
      caseDetailsLists?.id && String(caseDetailsLists.id) === String(id)
        ? caseDetailsLists
        : null;
    const motorData =
      motorCaseDetailsLists?.id && String(motorCaseDetailsLists.id) === String(id)
        ? motorCaseDetailsLists
        : null;
    const src = motorData || healthData || caseDetailsLists || motorCaseDetailsLists;
    if (!src) return false;
    if (src?.claim_type_category === CLAIM_TYPE_CATEGORY.MOTOR) return true;
    if (src?.motor_od_details || src?.motorOdDetails) return true;
    if (isMotorClaimType(src?.claimTypeCaseDetails)) return true;
    return false;
  }, [location.pathname, caseDetailsLists, motorCaseDetailsLists, id]);

  const activeCaseDetails = isMotorCase ? motorCaseDetailsLists : caseDetailsLists;
  const activeCaseErrors = isMotorCase ? errorsMotorCaseDetails : errorsCaseDetails;
  const activeChangedStatus = isMotorCase
    ? changedMotorCaseDetailsStatus
    : changedCaseDetailsStatus;
  const activeCaseLoading = isMotorCase ? loadingMotorCaseDetails : loadingCaseDetails;
  const resetCaseDetailsStatusType = isMotorCase
    ? "RESET_MOTOR_CASE_DETAILS_STATUS"
    : "RESET_DELETE_CASE_DETAILS_STATUS";

  useEffect(() => {
    if (show && auth?.token) {
      dispatch(getMasterInsuranceList(auth.token));
      dispatch(getAllStateList(auth.token));
      if (!isMotorCase) {
        dispatch(getAllRelationshipList(auth.token));
        dispatch(getAllOccupationList(auth.token));
        dispatch(getAllLocalityList(auth.token));
        dispatch(getAllEducationalList(auth.token));
        dispatch(getAllJobList(auth.token));
        dispatch(getAllRoomCategoryList(auth.token));
        dispatch(getAllIncomeDetailsList(auth.token));
        dispatch(getAllInjuryTypeList(auth.token));
        dispatch(getMasterHospitalList(auth.token));
      }
      dispatch(
        getMasterClaimTypeList(
          auth.token,
          isMotorCase ? CLAIM_TYPE_CATEGORY.MOTOR : CLAIM_TYPE_CATEGORY.HEALTH
        )
      );
      dispatch(getMasterCaseManagerList(auth?.token));
      dispatch(getMasterInsuranceTpaList(auth?.token));
    }
  }, [show, auth?.token, dispatch, isMotorCase]);

  useEffect(() => {
    if (show && auth?.token && insuranceId) {
      dispatch(getAllInsuranceManagerWiseList(auth.token, insuranceId));
    }
  }, [show, auth?.token, insuranceId, dispatch]);

  useEffect(() => {
    if (show && auth?.token && stateId) {
      dispatch(getAllCityStateWiseList(auth.token, stateId));
    }
  }, [show, auth?.token, stateId, dispatch]);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    if (show && auth?.token && id) {
      dispatch(fetchCaseDetailsById(auth.token, id, location.pathname));
    }
  }, [show, auth?.token, id, location.pathname, dispatch]);

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(fetchCaseDetailsById(auth?.token, editId, location.pathname));
    }
  }, [auth, editId, location.pathname, dispatch]);
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    console.log("form : ",formData);
    if(id)
    {
      if (isMotorCase) {
        dispatch(
          updateMotorCaseDetailsData(
            auth?.token,
            {
              ...formData,
              motor_od_details: buildMotorOdUpdatePayload(formData),
            },
            id
          )
        );
      } else {
        dispatch(
          updateCaseDetailsData(auth?.token, {
            ...formData,
            patient_kyc_details: kycEntries,
          }, id)
        );
      }
    }
  };

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);


  useEffect(()=>{
    if(id)
    {
      if(activeCaseDetails && Object.keys(activeCaseDetails).length>0)
      {
        const motorOdSource =
          activeCaseDetails?.motor_od_details || activeCaseDetails?.motorOdDetails;

        // Reset local KYC UI state when loading new case response
        setKycType(null);
        setKycNumber("");
        setKycFormatNote("");
        setKycValidationError("");

        setFormData({
          claim_number: activeCaseDetails?.claim_number,
          policy_number: activeCaseDetails?.policy_number,
          insurance_id: activeCaseDetails?.insurance_id,
          manager_id: activeCaseDetails?.manager_id,
          hospital_id: activeCaseDetails?.hospital_id,
          claim_type: activeCaseDetails?.claim_type,
          case_open_date: activeCaseDetails?.case_open_date,
          case_open_time: activeCaseDetails?.case_open_time,
          case_close_date: activeCaseDetails?.case_close_date,
          case_close_time: activeCaseDetails?.case_close_time,
          first_trigger: activeCaseDetails?.first_trigger,
          diagnosis: activeCaseDetails?.diagnosis,
          primary_name: activeCaseDetails?.primary_name,
          primary_phone: activeCaseDetails?.primary_phone,
          primary_email: activeCaseDetails?.primary_email,
          primary_state: activeCaseDetails?.primaryCityCaseDetails?.cities_state?.state_code,
          primary_city: activeCaseDetails?.primaryCityCaseDetails?.city_code,
          primary_address: activeCaseDetails?.primary_address,
          primary_pincode: activeCaseDetails?.primary_pincode,
          insured_dob: activeCaseDetails?.insured_dob,
          insured_gender: activeCaseDetails?.insured_gender,
          policy_period_from: activeCaseDetails?.policy_period_from,
          policy_period_to: activeCaseDetails?.policy_period_to,
          sum_assured: activeCaseDetails?.sum_assured,
          claim_amount: activeCaseDetails?.claim_amount,
          patient_name: activeCaseDetails?.patient_name,
          is_patient_primary_same: activeCaseDetails?.is_patient_primary_same,
          patient_phone: activeCaseDetails?.patient_phone,
          patient_email: activeCaseDetails?.patient_email,
          patient_state: activeCaseDetails?.patientCityCaseDetails?.cities_state?.state_code,
          patient_city: activeCaseDetails?.patientCityCaseDetails?.city_code,
          patient_address: activeCaseDetails?.patient_address,
          patient_pincode: activeCaseDetails?.patient_pincode,
          patient_gender: activeCaseDetails?.patient_gender,
          patient_dob: activeCaseDetails?.patient_dob,
          patient_relation: activeCaseDetails?.patient_relation,
          patient_occupation: activeCaseDetails?.patient_occupation,
          locality_id: activeCaseDetails?.locality_id,
          educational_id: activeCaseDetails?.educational_id,
          job_details_id: activeCaseDetails?.job_details_id,
          room_category: activeCaseDetails?.room_category,
          income_details_id: activeCaseDetails?.income_details_id,
          injury_type: activeCaseDetails?.injury_type,
          attendent_name: activeCaseDetails?.attendent_name,
          attendent_mobile: activeCaseDetails?.attendent_mobile,
          date_of_injury: activeCaseDetails?.date_of_injury,
          time_of_injury: activeCaseDetails?.time_of_injury,
          date_of_admission: activeCaseDetails?.date_of_admission,
          time_of_admission: activeCaseDetails?.time_of_admission,
          date_of_discharge: activeCaseDetails?.date_of_discharge,
          dr_name: activeCaseDetails?.dr_name,
          caseManagerId: activeCaseDetails?.caseManagerId,
          tpa_case: activeCaseDetails?.tpa_case,
          tpa_id: activeCaseDetails?.tpa_id,
          ...mapMotorOdDetailsToFormData(motorOdSource),
        });
        const incomingKyc =
          activeCaseDetails?.patient_kyc_details ||
          activeCaseDetails?.patientKycDetails ||
          activeCaseDetails?.kyc_details ||
          activeCaseDetails?.kycDetails ||
          [];

        const kycArray = Array.isArray(incomingKyc)
          ? incomingKyc
          : incomingKyc
            ? [incomingKyc]
            : [];

        const mappedKyc = kycArray.map((item) => {
          const rawType =
            item?.kyc_type ||
            item?.kycType ||
            item?.kyc_type_name ||
            item?.documentType ||
            item?.type ||
            "";
          const rawNumber =
            item?.kyc_number ||
            item?.kycNumber ||
            item?.kyc_number_value ||
            item?.documentNumber ||
            item?.number ||
            "";

          return {
            kyc_type: normalizeKycTypeValue(rawType),
            kyc_number: rawNumber,
          };
        });

        setKycEntries(
          mappedKyc.filter((k) => String(k?.kyc_type ?? "").trim().length > 0 && String(k?.kyc_number ?? "").trim().length > 0)
        );

        // Set insuranceId to load managers
        if(activeCaseDetails?.insurance_id) {
          setInsuranceId(activeCaseDetails?.insurance_id);
        }
        // Set stateId to load cities for primary and patient
        if(activeCaseDetails?.primaryCityCaseDetails?.cities_state?.state_code) {
          setStateId(activeCaseDetails?.primaryCityCaseDetails?.cities_state?.state_code);
        }
      }
    }
  },[activeCaseDetails, id])


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };

  const selectMobileHandler = (e) => {
    const { value, name } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const inputDateHandler = (name,value) => {
    if (value) {
      const dateValue = getDateTimeMysqlGivenFormatYmd(value);
      const timeValue = getCurrentTimeMysql(value);
      
      if (name === 'case_open_date') {
        setFormData({ ...formData, case_open_date: dateValue, case_open_time: timeValue });
      } else if (name === 'case_close_date') {
        setFormData({ ...formData, case_close_date: dateValue, case_close_time: timeValue });
      } else {
        setFormData({ ...formData, [name]: dateValue });
      }
    } else {
      // Handle clear case
      if (name === 'case_open_date') {
        setFormData({ ...formData, case_open_date: null, case_open_time: null });
      } else if (name === 'case_close_date') {
        setFormData({ ...formData, case_close_date: null, case_close_time: null });
      } else {
        setFormData({ ...formData, [name]: null });
      }
    }
  };

  const inputTimeHandler = (name, value) => {
    if (!value) {
      setFormData((prev) => ({ ...prev, [name]: null }));
      return;
    }
    const hours = String(value.getHours()).padStart(2, "0");
    const minutes = String(value.getMinutes()).padStart(2, "0");
    setFormData((prev) => ({ ...prev, [name]: `${hours}:${minutes}:00` }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const kycTypeOptions = [
    { label: "Aadhar Card", value: "Aadhar Card" },
    { label: "PAN Card", value: "PAN Card" },
    { label: "Voter ID", value: "Voter ID" },
    { label: "Driving License", value: "Driving License" },
  ];

  const normalizeKycTypeValue = (type) => {
    if (type === "Aadhaar Card") return "Aadhar Card";
    return type;
  };

  const kycDocumentConfigs = {
    "Aadhar Card": {
      pattern: /^\d{12}$/,
      format: "12 digits (e.g., 123456789012)",
    },
    "PAN Card": {
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      format: "ABCDE1234F format",
    },
    "Voter ID": {
      pattern: /^[A-Z]{3}[0-9]{7}$/,
      format: "3 letters + 7 digits (e.g., ABC1234567)",
    },
    "Driving License": {
      pattern: /^[A-Z]{2}[0-9]{13}$/,
      format: "2 letters + 13 digits (e.g., MH0123456789012)",
    },
  };

  const getKycPlaceholder = (type) => {
    if (!type) return t("Enter KYC Number");
    if (type === "Aadhar Card") return t("Enter Aadhar Number");
    if (type === "PAN Card") return t("Enter PAN Number");
    if (type === "Voter ID") return t("Enter Voter ID Number");
    if (type === "Driving License") return t("Enter Driving License Number");
    return t("Enter KYC Number");
  };

  const normalizeKycInput = (type, rawValue) => {
    const value = String(rawValue ?? "");
    const trimmed = value.trim();
    if (!type) return trimmed;
    if (type === "PAN Card" || type === "Voter ID" || type === "Driving License") {
      return trimmed.toUpperCase();
    }
    return trimmed;
  };

  const validateKycNumber = (type, rawValue) => {
    if (!type) return "";
    const config = kycDocumentConfigs[type];
    if (!config) return "";
    const normalized = normalizeKycInput(type, rawValue);
    if (!normalized.length) return "";
    const isValid = config.pattern.test(normalized);
    if (isValid) return "";
    return `Please enter valid ${type} number in correct format.`;
  };

  const handleSaveKycRow = () => {
    const nextType = normalizeKycTypeValue(kycType);
    if (!nextType) {
      toast.error(t("Please select KYC Type"));
      return;
    }

    const normalized = normalizeKycInput(nextType, kycNumber);
    if (!normalized.length) {
      toast.error(t("Please enter KYC Number"));
      return;
    }

    const validationMessage = validateKycNumber(nextType, normalized);
    if (validationMessage) {
      toast.error(validationMessage);
      setKycValidationError(validationMessage);
      return;
    }

    setKycEntries((prev) => [
      ...prev,
      {
        kyc_type: nextType,
        kyc_number: normalized,
      },
    ]);

    setKycType(null);
    setKycNumber("");
    setKycFormatNote("");
    setKycValidationError("");
  };

  const customCheckboxMargin = {
    marginBottom: '20px',
    fontSize: '12pt',
    color: 'blue',
  };

  
  useEffect(() => {
    if (activeChangedStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: activeChangedStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetCaseDetailsStatusType });
    }
  }, [activeChangedStatus, dispatch, onHide, resetCaseDetailsStatusType]);

  useEffect(() => {
    if (show && auth?.token && caseManagerUserTypeId) {
      dispatch(getMasterUserUserTypeWiseList(auth?.token, caseManagerUserTypeId));
    }
  }, [show, auth?.token, caseManagerUserTypeId, dispatch]);

  useEffect(() => {
    if (formData?.caseManagerId && !caseManagerUserTypeId && masterUsertypeLists && masterUsertypeLists.length > 0 && auth?.token && show) {
      // Automatically select first user type to load users and find case manager
      const firstUserType = masterUsertypeLists[0];
      if (firstUserType && firstUserType.id) {
        setCaseManagerUserTypeId(firstUserType.id);
        dispatch(getMasterUserUserTypeWiseList(auth.token, firstUserType.id));
      }
    }
  }, [formData?.caseManagerId, masterUsertypeLists, caseManagerUserTypeId, auth?.token, show, dispatch]);

  // Find user type from case manager when users are loaded
  useEffect(() => {
    if (formData?.caseManagerId && masterCaseManagerLists && masterCaseManagerLists.length > 0) {
      const caseManager = masterCaseManagerLists.find(user => user.id === formData.caseManagerId);
      if(caseManager && caseManager.adminUserType && caseManager.adminUserType.id) {
        // Only update if different from current user type
        if(caseManager.adminUserType.id !== caseManagerUserTypeId) {
          setCaseManagerUserTypeId(caseManager.adminUserType.id);
        }
      } else if (caseManagerUserTypeId && masterUsertypeLists && masterUsertypeLists.length > 0) {
        // Case manager not found in current user list, try next user type
        const currentIndex = masterUsertypeLists.findIndex(ut => ut.id === caseManagerUserTypeId);
        if (currentIndex >= 0 && currentIndex < masterUsertypeLists.length - 1 && auth?.token) {
          const nextUserType = masterUsertypeLists[currentIndex + 1];
          setCaseManagerUserTypeId(nextUserType.id);
          dispatch(getMasterUserUserTypeWiseList(auth.token, nextUserType.id));
        }
      }
    }
  }, [formData?.caseManagerId, masterCaseManagerLists, caseManagerUserTypeId, masterUsertypeLists, auth?.token, dispatch]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(id && activeCaseDetails && Object.keys(activeCaseDetails).length > 0) ? t("Update Case Details") : t("Add Case Details")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {activeCaseErrors?.data?.message && (
          <div className="alert alert-danger">
            {activeCaseErrors?.data?.message}
          </div>
        )}

        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <Row>
                  <Col lg={4}>
                    <FormInput
                      label={t("Claim Number")}
                      type="text"
                      placeholder={t("Enter Claim Number")}
                      errors={errorsCaseDetails?.data}
                      value={formData.claim_number}
                      name="claim_number"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      disabled={![1, 2].includes(Number(auth?.data?.user_type_id))}
                    />
                  </Col>

                  <Col lg={4}>
                    <FormInput
                      label={t("Policy Number")}
                      type="text"
                      placeholder={t("Enter Policy Number")}
                      errors={errorsCaseDetails?.data}
                      value={formData.policy_number}
                      name="policy_number"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label className="d-block">{t("TPA Case")}</Form.Label>
              <div className="d-flex gap-2 align-items-center" style={{ minHeight: 38 }}>
                <Form.Check
                  type="radio"
                  id="tpa_case_yes"
                  name="tpa_case"
                  label={t("Yes")}
                  checked={formData?.tpa_case === "Yes"}
                  onChange={() => {
                    // reset dependent selections when toggling to Yes
                    setFormData((prev) => ({
                      ...prev,
                      tpa_case: "Yes",
                      tpa_id: null,
                      insurance_id: null,
                      manager_id: null,
                    }));
                    setInsuranceId(null);
                  }}
                />
                <Form.Check
                  type="radio"
                  id="tpa_case_no"
                  name="tpa_case"
                  label={t("No")}
                  checked={formData?.tpa_case === "No"}
                  onChange={() => {
                    // revert to existing flow when No
                    setFormData((prev) => ({
                      ...prev,
                      tpa_case: "No",
                      tpa_id: null,
                    }));
                  }}
                />
              </div>
              {errorsCaseDetails?.data?.tpa_case && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.tpa_case}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          {formData?.tpa_case === "Yes" && (
            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label>{t("TPA")}</Form.Label>
                <Select
                  options={Array.isArray(masterInsuranceTpaList) ? masterInsuranceTpaList : []}
                  values={
                    Array.isArray(masterInsuranceTpaList)
                      ? masterInsuranceTpaList?.filter((x) => x?.id === formData?.tpa_id)
                      : []
                  }
                  name="tpa_id"
                  labelField={"name"}
                  valueField={"id"}
                  searchBy={"name"}
                  placeholder={t("Select TPA")}
                  loading={loadingMaster}
                  onChange={(selectedData) => {
                    selectHandler2(selectedData[0]?.id, "tpa_id");
                    // when TPA changes, reset insurance/manager so user selects insurance after TPA
                    setFormData((prev) => ({
                      ...prev,
                      insurance_id: null,
                      manager_id: null,
                    }));
                    setInsuranceId(null);
                  }}
                  styles={customSelectStyles}
                />
                {errorsCaseDetails?.data?.tpa_id && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{errorsCaseDetails?.data?.tpa_id}</p>
                  </div>
                )}
              </Form.Group>
            </Col>
          )}

                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Insurance Company")}</Form.Label>
                      <Select
                        options={masterInsuranceList}
                        values={masterInsuranceList?.filter(insurance => insurance.id === formData.insurance_id)}
                        name="insurance_id"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Insurance Company")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "insurance_id")
                          setInsuranceId(selectedData[0]?.id);
                        }}
                        styles={customSelectStyles}
                        disabled={![1, 2].includes(Number(auth?.data?.user_type_id))}
                      />
                      
                      {errorsCaseDetails?.data?.insurance_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.insurance_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {formData.insurance_id && (
                    <>
                      <Col lg={4}>
                        <Form.Group className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <Form.Label>{t("Client Company Case Manager")}</Form.Label>
                            <button 
                              className="btn btn-link p-0 text-decoration-none" 
                              onClick={() => setShowInsuranceManagerModel(true)}
                              type="button"
                            >
                              {t("Add New Manager")}
                            </button>
                          </div>
                          <Select
                            options={Array.isArray(masterInsuranceManagerWiseList) ? masterInsuranceManagerWiseList : []}
                            values={Array.isArray(masterInsuranceManagerWiseList) ? masterInsuranceManagerWiseList.filter(manager => manager.id === formData.manager_id) : []}
                            name="manager_id"
                            labelField={"name"}
                            valueField={"id"}
                            searchBy={"name"}
                            placeholder={t("Select Manager")}
                            loading={loadingMaster}
                            onChange={(selectedData) => {
                              selectHandler2(selectedData[0]?.id, "manager_id");
                            }}
                            styles={customSelectStyles}
                          />
                          {errorsCaseDetails?.data?.manager_id && (
                            <div className="invalid-feedback d-block">
                              <p className="text-danger">{errorsCaseDetails?.data?.manager_id}</p>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {!isMotorCase && (
                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label>{t("Hospital Name")}</Form.Label>
                        <button 
                          className="btn btn-link p-0 text-decoration-none" 
                          onClick={() => setShowHospitalModel(true)}
                          type="button"
                        >
                          {t("Add New Hospital")}
                        </button>
                      </div>
                      <Select
                        options={masterHospitalList}
                        values={masterHospitalList?.filter(hospital => hospital.id === formData.hospital_id)}
                        name="hospital_id"
                        labelField={"hospital_name"}
                        valueField={"id"}
                        searchBy={"hospital_name"}
                        placeholder={t("Select Hospital Name")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "hospital_id")
                        }}
                        styles={customSelectStyles}
                        disabled={![1, 2].includes(Number(auth?.data?.user_type_id))}
                      />
                      
                      {errorsCaseDetails?.data?.hospital_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.hospital_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  )}

                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label>{t("Claim Type")}</Form.Label>
                        <button 
                          className="btn btn-link p-0 text-decoration-none" 
                          onClick={() => setShowTypeOfClaimModel(true)}
                          type="button"
                        >
                          {t("Add New Claim Type")}
                        </button>
                      </div>
                      <Select
                        options={masterClaimTypeList}
                        values={masterClaimTypeList?.filter(claim => claim.id === formData.claim_type)}
                        name="claim_type"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Claim Type")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "claim_type")
                        }}
                        styles={customSelectStyles}
                        disabled={![1, 2].includes(Number(auth?.data?.user_type_id))}
                      />
                      
                      {errorsCaseDetails?.data?.claim_type && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.claim_type}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Case Open Date Time")}</Form.Label>
                      <DatePicker
                        selected={
                          formData?.case_open_date
                            ? new Date(`${formData?.case_open_date}T${formData?.case_open_time}`)
                            : null
                        }
                        onChange={(value) => inputDateHandler('case_open_date', value)}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="Time"
                        todayButton="Today"
                        isClearable
                      />

                      {errorsCaseDetails?.data?.case_open_date && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.case_open_date}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {formData.case_open_date && (<>
                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("Case Close Date")}</Form.Label>
                        <DatePicker
                          selected={
                            formData?.case_close_date
                              ? new Date(`${formData?.case_close_date}T${formData?.case_close_time}`)
                              : null
                          }
                          onChange={(value) => inputDateHandler('case_close_date', value)}
                          dateFormat="yyyy-MM-dd HH:mm:ss"
                          className="form-control"
                          withPortal
                          showYearDropdown
                          scrollableYearDropdown
                          showTimeSelect
                          timeIntervals={15}
                          timeCaption="Time"
                          todayButton="Today"
                          isClearable
                        />

                        {errorsCaseDetails?.data?.case_close_date && (
                          <div className="invalid-feedback d-block">
                            <p className="text-danger">{errorsCaseDetails?.data?.case_close_date}</p>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>)}

                  {/* <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("User Type")}</Form.Label>
                      <Select
                        options={masterUsertypeLists}
                        values={masterUsertypeLists?.filter(
                          (usertype) => usertype.id === caseManagerUserTypeId
                        )}
                        name="caseManagerUserTypeId"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          const selectedId = selectedData[0]?.id;
                          setCaseManagerUserTypeId(selectedId);
                          // reset selected manager when type changes
                          setFormData((prev) => ({ ...prev, caseManagerId: null }));
                        }}
                        styles={customSelectStyles}
                      />
                    </Form.Group>
                  </Col> */}

                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Internal Case Manager")}</Form.Label>
                      <Select
                        options={masterCaseManagerLists?.map(user => ({
                          ...user,
                          customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Total Cases: ${user?.totalCaseCount} | Doctor Report Cases: ${user?.doctorReportCaseCount} | Att: ${user?.todayAttendance}`
                        }))}
                        values={masterCaseManagerLists?.filter(user => user?.id === formData?.caseManagerId)?.map(user => ({
                          ...user,
                          customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Total Cases: ${user?.totalCaseCount} | Doctor Report Cases: ${user?.doctorReportCaseCount} | Att: ${user?.todayAttendance}`
                        }))}
                        name="caseManagerId"
                        labelField="customLabel"
                        valueField="id"
                        searchBy="name"
                        placeholder={t("Select Investigator")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          if (selectedData.length > 0) {
                            selectHandler2(selectedData[0]?.id, "caseManagerId");
                          }
                        }}
                        itemRenderer={({ item, itemIndex, props, state, methods }) => (
                          <div 
                            onClick={() => methods.addItem(item)}
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #eee',
                              backgroundColor: state.values.find(val => val.id === item.id) ? '#e3f2fd' : 'white'
                            }}
                          >
                            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                              {item.name} <span style={{ color: '#666', fontSize: '0.9em' }}>({item?.adminUserType?.name})</span>
                            </div>
                            <div style={{ fontSize: '0.85em', color: '#555', marginBottom: '3px' }}>
                              {item?.citiesAdminUsers?.city_name}, {item?.citiesAdminUsers?.cities_state?.state_name}
                            </div>
                            <div style={{ display: 'flex', gap: '15px', fontSize: '0.8em', marginTop: '5px' }}>
                              <span style={{ color: '#FF9800' }}>
                                <strong>Total Cases:</strong> {item?.totalCaseCount}
                              </span>
                              <span style={{ color: '#FF9800' }}>
                                <strong>Doctor Report Cases:</strong> {item?.doctorReportCaseCount}
                              </span>
                              <span style={{ 
                                color: item?.todayAttendance === 'Present' ? '#4CAF50' : item?.todayAttendance === 'Not Working' ? '#F44336' : '#666',
                                fontWeight: '500'
                              }}>
                                <strong>Att:</strong> {item?.todayAttendance}
                              </span>
                            </div>
                          </div>
                        )}
                        styles={customSelectStyles}
                      />
                      {/* <Select
                        options={masterCaseManagerLists.map((user) => ({
                          ...user,
                          label: `${user.name}`,
                        }))}
                        values={masterCaseManagerLists
                          .map((user) => ({
                            ...user,
                            label: `${user.name}`,
                          }))
                          .filter((user) => user.id === formData.caseManagerId)}
                        name="caseManagerId"
                        labelField="label"
                        valueField="id"
                        searchBy="label"
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "caseManagerId");
                        }}
                        styles={customSelectStyles}
                      /> */}

                      {errorsCaseDetails?.data?.caseManagerId && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">
                            {errorsCaseDetails?.data?.caseManagerId}
                          </p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <Row>
                  <Col lg={6}>
                    <FormInput
                      label={t("First Trigger")}
                      type="textarea"
                      placeholder={t("Enter First Trigger")}
                      errors={errorsCaseDetails?.data}
                      value={formData.first_trigger}
                      name="first_trigger"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      rows={6}
                    />
                  </Col>

                  <Col lg={6}>
                    <FormInput
                      label={t("Diagnosis")}
                      type="textarea"
                      placeholder={t("Enter Diagnosis")}
                      errors={errorsCaseDetails?.data}
                      value={formData.diagnosis}
                      name="diagnosis"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      rows={6}
                    />
                  </Col>
                </Row>
                </Card.Body>
            </Card>
          </Col>
        </Row>

        {isMotorCase && (
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <MotorCaseUpdateFields
                  t={t}
                  formData={formData}
                  inputHandler={inputHandler}
                  inputDateHandler={inputDateHandler}
                  inputTimeHandler={inputTimeHandler}
                  selectMobileHandler={selectMobileHandler}
                  errors={activeCaseErrors?.data}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
        )}

        {!isMotorCase && (
        <>
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                {errors?.data?.message && (
                  <div className="alert alert-danger">
                    {errors.data.message}
                  </div>
                )}
                <Row>
                  <h3 style={{ color: '#d10b0b' }}>Patient Details -: </h3>
                  <Col lg={3}>
                    <FormInput
                      label={t("Patient Name")}
                      type="text"
                      placeholder={t("Enter Patient Name")}
                      errors={errorsCaseDetails?.data}
                      value={formData.patient_name}
                      name="patient_name"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      disabled={formData?.sameAsPrimary}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Patient Phone Number")}
                      type="text"
                      placeholder={t("Enter Patient Phone Number")}
                      errors={errorsCaseDetails?.data}
                      value={formData.patient_phone}
                      name="patient_phone"
                      onChange={selectMobileHandler}
                      containerClass={"mb-3"}
                      disabled={formData?.sameAsPrimary}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Patient Email")}
                      type="text"
                      placeholder={t("Enter Patient Email")}
                      errors={errorsCaseDetails?.data}
                      value={formData.patient_email}
                      name="patient_email"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      disabled={formData?.sameAsPrimary}
                    />
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Date Of Birth")}</Form.Label>
                      <DatePicker
                        selected={formData.patient_dob}
                        onChange={(value) => inputDateHandler('patient_dob', value)}
                        dateFormat="yyyy-MM-dd"
                        maxDate={(() => {
                          const date = new Date();
                          return date;
                        })()}
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        showMonthDropdown
                        scrollableMonthDropdown
                        isClearable
                      />
                      {errorsCaseDetails?.data?.patient_dob && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_dob}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Gender")}</Form.Label>
                      <Select
                        options={genderList}
                        values={genderList?.filter(gender => gender?.id === formData?.patient_gender)}
                        name="patient_gender"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Patient Gender")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "patient_gender")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.patient_gender && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_gender}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Patient Address")}
                      type="text"
                      placeholder={t("Enter Patient Address")}
                      errors={errorsCaseDetails?.data}
                      value={formData.patient_address}
                      name="patient_address"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      disabled={formData?.sameAsPrimary}
                    />
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Patient State")}</Form.Label>
                      <Select
                        options={masterStateLists}
                        values={masterStateLists?.filter(state => state?.state_code === formData?.patient_state)}
                        name="patient_state"
                        labelField={"state_name"}
                        valueField={"state_code"}
                        searchBy={"state_name"}
                        placeholder={t("Enter Patient State")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.state_code, "patient_state")
                          setStateId(selectedData[0]?.state_code);
                        }}
                        styles={customSelectStyles}
                        disabled={formData?.sameAsPrimary}
                      />
                      
                      {errorsCaseDetails?.data?.patient_state && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_state}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Patient City")}</Form.Label>
                      <Select
                        options={masterCityStateWiseLists}
                        values={masterCityStateWiseLists?.filter(city => city?.city_code === formData?.patient_city)}
                        name="patient_city"
                        labelField={"city_name"}
                        valueField={"city_code"}
                        searchBy={"city_name"}
                        placeholder={t("Select Patient City")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.city_code, "patient_city")
                        }}
                        styles={customSelectStyles}
                        disabled={formData?.sameAsPrimary}
                      />
                      
                      {errorsCaseDetails?.data?.patient_city && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_city}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Patient Pincode")}
                      type="text"
                      placeholder={t("Enter Patient Pincode")}
                      errors={errorsCaseDetails?.data}
                      value={formData.patient_pincode}
                      name="patient_pincode"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                      disabled={formData?.sameAsPrimary}
                    />
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Patient Relationship")}</Form.Label>
                      <Select
                        options={masterRelationshipList}
                        values={masterRelationshipList?.filter(education => education?.id === formData?.patient_relation)}
                        name="patient_relation"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Patient Relationship")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "patient_relation")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.patient_relation && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_relation}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Patient Occupation")}</Form.Label>
                      <Select
                        options={masterOccupationList}
                        values={masterOccupationList?.filter(job => job?.id === formData?.patient_occupation)}
                        name="patient_occupation"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Patient Occupation")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "patient_occupation")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.patient_occupation && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.patient_occupation}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Row>
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("KYC Type")}</Form.Label>
                      <Select
                        options={kycTypeOptions}
                        values={
                          kycType
                            ? kycTypeOptions.filter((x) => x.value === kycType)
                            : []
                        }
                        name="kyc_type"
                        labelField={"label"}
                        valueField={"value"}
                        searchBy={"label"}
                        placeholder={t("Select KYC Type")}
                        disabled={formData?.sameAsPrimary}
                        onChange={(selectedData) => {
                          const nextType = normalizeKycTypeValue(selectedData[0]?.value);
                          setKycType(nextType);
                          setKycNumber("");
                          setKycValidationError("");
                          setKycFormatNote(kycDocumentConfigs[nextType]?.format || "");
                        }}
                        styles={customSelectStyles}
                      />
                    </Form.Group>
                    </Col>
                    <Col lg={4}>
                    {kycType && (
                      <div className="mb-3">
                        <div className="d-flex gap-2 align-items-end">
                          <div className="flex-grow-1">
                            <Form.Label className="d-block">{t("KYC Number")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={getKycPlaceholder(kycType)}
                              value={kycNumber}
                              disabled={formData?.sameAsPrimary}
                              isInvalid={!!kycValidationError}
                              onChange={(e) => {
                                const normalized = normalizeKycInput(kycType, e.target.value);
                                setKycNumber(normalized);
                                setKycValidationError(validateKycNumber(kycType, normalized));
                              }}
                            />
                          </div>
                          <Button
                            type="button"
                            size="sm"
                            onClick={handleSaveKycRow}
                            disabled={formData?.sameAsPrimary}
                          >
                            {t("Save")}
                          </Button>
                        </div>

                        {(kycFormatNote || kycValidationError) && (
                          <div className="mt-2">
                            {kycFormatNote && (
                              <div className="text-muted" style={{ fontSize: 13 }}>
                                {kycFormatNote}
                              </div>
                            )}
                            {kycValidationError && (
                              <div className="invalid-feedback d-block">
                                <p className="text-danger">{kycValidationError}</p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    </Col>
                    <Col lg={4}>
                    {kycEntries.length > 0 && (
                      <div className="mt-2">
                        <table className="table table-bordered table-sm mb-0">
                          <thead>
                            <tr>
                              <th>{t("Sr. No.")}</th>
                              <th>{t("KYC Type")}</th>
                              <th>{t("KYC Number")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {kycEntries.map((row, idx) => (
                              <tr key={`${row?.kyc_type ?? "kyc"}-${idx}`}>
                                <td>{idx + 1}</td>
                                <td>{row?.kyc_type}</td>
                                <td>{row?.kyc_number}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Col>
                  </Row>
                </Row>

                <Row>
                  <Col lg={12}>
                    <Form.Check
                      type="checkbox"
                      name="is_patient_primary_same"
                      containerClass={"mb-3"}
                      label={t("Click This If Patient & Insured Member Are Same")}
                      checked={formData?.is_patient_primary_same === true}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        inputHandler({ target: { name: "is_patient_primary_same", value: isChecked } });

                        setFormData((prevData) => {
                          const updatedFormData = isChecked
                            ? {
                                ...prevData,
                                is_patient_primary_same: true,
                                primary_name: prevData.patient_name || "",
                                primary_phone: prevData.patient_phone || "",
                                primary_email: prevData.patient_email || "",
                                primary_address: prevData.patient_address || "",
                                primary_state: prevData.patient_state || null,
                                primary_city: prevData.patient_city || null,
                                primary_pincode: prevData.patient_pincode || "",
                              }
                            : {
                                ...prevData,
                                is_patient_primary_same: false,
                                primary_name: "",
                                primary_phone: "",
                                primary_email: "",
                                primary_address: "",
                                primary_state: null,
                                primary_city: null,
                                primary_pincode: "",
                              };

                          return updatedFormData;
                        });
                      }}
                      style={customCheckboxMargin}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <Row>
                  <h3 style={{ color: '#d10b0b' }}>Primary Insured Details -: </h3>
                  <Col lg={3}>
                    <FormInput
                      label={t("Primary Insured Name")}
                      type="text"
                      placeholder={t("Enter Primary Insured Name")}
                      errors={errorsCaseDetails?.data}
                      value={formData.primary_name}
                      name="primary_name"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Primary Insured Phone Number")}
                      type="text"
                      placeholder={t("Enter Primary Insured Phone Number")}
                      errors={errorsCaseDetails?.data}
                      value={formData.primary_phone}
                      name="primary_phone"
                      onChange={selectMobileHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Primary Insured Email")}
                      type="text"
                      placeholder={t("Enter Primary Insured Email")}
                      errors={errorsCaseDetails?.data}
                      value={formData.primary_email}
                      name="primary_email"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Primary Insured Address")}
                      type="text"
                      placeholder={t("Enter Primary Insured Address")}
                      errors={errorsCaseDetails?.data}
                      value={formData.primary_address}
                      name="primary_address"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured DOB")}</Form.Label>
              <DatePicker
                selected={formData.insured_dob}
                onChange={(value) => inputDateHandler("insured_dob", value)}
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.insured_dob && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.insured_dob}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured Gender")}</Form.Label>
              <Select
                options={genderList}
                values={genderList?.filter(
                  (gender) => gender?.id === formData?.insured_gender
                )}
                name="insured_gender"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Primary Insured Gender")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "insured_gender");
                }}
                styles={customSelectStyles}
              />
              {errorsCaseDetails?.data?.insured_gender && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.insured_gender}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Primary Insured State")}</Form.Label>
                      <Select
                        options={masterStateLists}
                        values={masterStateLists?.filter(state => state?.state_code === formData?.primary_state)}
                        name="primary_state"
                        labelField={"state_name"}
                        valueField={"state_code"}
                        searchBy={"state_name"}
                        placeholder={t("Select Primary Insured State")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.state_code, "primary_state")
                          setStateId(selectedData[0]?.state_code);
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.primary_state && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.primary_state}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Primary Insured City")}</Form.Label>
                      <Select
                        options={masterCityStateWiseLists}
                        values={masterCityStateWiseLists?.filter(city => city?.city_code === formData?.primary_city)}
                        name="primary_city"
                        labelField={"city_name"}
                        valueField={"city_code"}
                        searchBy={"city_name"}
                        placeholder={t("Select Primary Insured City")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.city_code, "primary_city")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.primary_city && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.primary_city}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Primary Insured Pincode")}
                      type="text"
                      placeholder={t("Enter Primary Insured Pincode")}
                      errors={errorsCaseDetails?.data}
                      value={formData.primary_pincode}
                      name="primary_pincode"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Policy Period Start Date")}</Form.Label>
              <DatePicker
                selected={formData.policy_period_from}
                onChange={(value) => inputDateHandler("policy_period_from", value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.policy_period_from && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.policy_period_from}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Policy Period End Date")}</Form.Label>
              <DatePicker
                selected={formData.policy_period_to}
                onChange={(value) => inputDateHandler("policy_period_to", value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.policy_period_to && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.policy_period_to}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Sum Assured")}
              type="text"
              placeholder={t("Enter Sum Assured")}
              errors={errorsCaseDetails?.data}
              value={formData.sum_assured}
              name="sum_assured"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Claim Amount")}
              type="text"
              placeholder={t("Enter Claim Amount")}
              errors={errorsCaseDetails?.data}
              value={formData.claim_amount}
              name="claim_amount"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <Row>
                  <h3 style={{ color: '#d10b0b' }}>Others Details -: </h3>
                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Locality")}</Form.Label>
                      <Select
                        options={masterLocalityList}
                        values={masterLocalityList?.filter(locality => locality?.id === formData?.locality_id)}
                        name="locality_id"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Locality")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "locality_id")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.locality_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.locality_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Educational Details")}</Form.Label>
                      <Select
                        options={masterEducationalList}
                        values={masterEducationalList?.filter(education => education?.id === formData?.educational_id)}
                        name="educational_id"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Educational Details")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "educational_id")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.educational_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.educational_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Job Details")}</Form.Label>
                      <Select
                        options={masterJobList}
                        values={masterJobList?.filter(job => job?.id === formData?.job_details_id)}
                        name="job_details_id"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Job Details")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "job_details_id")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.job_details_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.job_details_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Room Category")}</Form.Label>
                      <Select
                        options={masterRoomCategoryList}
                        values={masterRoomCategoryList?.filter(room => room?.id === formData?.room_category)}
                        name="room_category"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Room Category")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "room_category")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.room_category && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.room_category}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Income Details")}</Form.Label>
                      <Select
                        options={masterIncomeDetailsList}
                        values={masterIncomeDetailsList?.filter(income => income?.id === formData?.income_details_id)}
                        name="income_details_id"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Income Details")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "income_details_id")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.income_details_id && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.income_details_id}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Injury Type")}</Form.Label>
                      <Select
                        options={masterInjuryTypeList}
                        values={masterInjuryTypeList?.filter(injury => injury?.id === formData?.injury_type)}
                        name="injury_type"
                        labelField={"name"}
                        valueField={"id"}
                        searchBy={"name"}
                        placeholder={t("Select Injury Type")}
                        loading={loadingMaster}
                        onChange={(selectedData) => {
                          selectHandler2(selectedData[0]?.id, "injury_type")
                        }}
                        styles={customSelectStyles}
                      />
                      
                      {errorsCaseDetails?.data?.injury_type && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.injury_type}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Attendent Name")}
                      type="text"
                      placeholder={t("Enter Attendent Name")}
                      errors={errorsCaseDetails?.data}
                      value={formData.attendent_name}
                      name="attendent_name"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Attendent Phone Number")}
                      type="text"
                      placeholder={t("Enter Attendent Phone Number")}
                      errors={errorsCaseDetails?.data}
                      value={formData.attendent_mobile}
                      name="attendent_mobile"
                      onChange={selectMobileHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Date Of Injury")}</Form.Label>
                      <DatePicker
                        selected={formData.date_of_injury}
                        onChange={(value) => inputDateHandler('date_of_injury', value)}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        isClearable
                      />
                      {errorsCaseDetails?.data?.date_of_injury && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.date_of_injury}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Time Of Injury")}</Form.Label>
              <DatePicker
                selected={formData?.time_of_injury ? new Date(`${getCurrentDateMysql()}T${formData?.time_of_injury}`) : null}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    time_of_injury: getCurrentTimeMysql(value),
                  })
                }
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="HH:mm:ss"
                className="form-control"
                withPortal
                isClearable
              />

              {errorsCaseDetails?.data?.time_of_injury && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.time_of_injury}</p>
                </div>
              )}
            </Form.Group>
          </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Date Of Admission")}</Form.Label>
                      <DatePicker
                        selected={formData.date_of_admission}
                        onChange={(value) => inputDateHandler('date_of_admission', value)}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        isClearable
                      />
                      {errorsCaseDetails?.data?.date_of_admission && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.date_of_admission}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Time Of Admission")}</Form.Label>
                      <DatePicker
                        selected={formData?.time_of_admission ? new Date(`${getCurrentDateMysql()}T${formData?.time_of_admission}`) : null}
                        onChange={(value) =>
                          setFormData({
                            ...formData,
                            time_of_admission: getCurrentTimeMysql(value),
                          })
                        }
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="HH:mm:ss"
                        className="form-control"
                        withPortal
                        isClearable
                      />

                      {errorsCaseDetails?.data?.time_of_admission && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.time_of_admission}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("Date Of Discharge")}</Form.Label>
                      <DatePicker
                        selected={formData.date_of_discharge}
                        onChange={(value) => inputDateHandler('date_of_discharge', value)}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        isClearable
                      />
                      {errorsCaseDetails?.data?.date_of_discharge && (
                        <div className="invalid-feedback d-block">
                          <p className="text-danger">{errorsCaseDetails?.data?.date_of_discharge}</p>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <FormInput
                      label={t("Doctor Name")}
                      type="text"
                      placeholder={t("Enter Doctor Name")}
                      errors={errorsCaseDetails?.data}
                      value={formData.dr_name}
                      name="dr_name"
                      onChange={inputHandler}
                      containerClass={"mb-3"}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </>
        )}
        <div className="d-flex justify-content-center">
          {loading ? 
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          :
            <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
            {(id && activeCaseDetails && Object.keys(activeCaseDetails).length > 0) ? t("Update") : t("Add")}
            </Button>
          }
        </div>
      </Modal.Body>
      <AddInsuranceManagerManager show={showInsuranceManagerModel} onHide={() => hideInsuranceManagerModel()}  />
      <AddHospital show={showHospitalModel} onHide={() => hideHospitalModel()}  />
      <AddTypeOfClaim show={showTypeOfClaimModel} onHide={() => hideTypeOfClaimModel()}  />
      {(loadingCaseDetails || loadingMotorCaseDetails) && <Preloader />}
    </Modal>
  );
};

export default UpdateCaseDetails;
